import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { NavPage, TRAY_ID } from '../../nav/navTypes';
import { PAGE_CATALOG } from '../../nav/pageCatalog';
import { EditorHandlers } from './editorTypes';

interface Props {
  tray: NavPage[];
  handlers: EditorHandlers;
}

/** "Nicht zugeordnet" drop zone with draggable chips for unassigned pages. */
export default function NavTrayZone({ tray, handlers }: Props) {
  return (
    <Box
      data-testid="nav-tray"
      sx={{ border: '1px dashed', borderColor: 'grey.500', p: 1.5, bgcolor: 'background.paper' }}
      onDragOver={handlers.allowDrop}
      onDrop={() => handlers.dropOnTray()}
    >
      <Typography variant="overline" color="text.secondary">
        Nicht zugeordnet
      </Typography>
      {tray.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Alle Seiten sind dieser Rolle zugeordnet.
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
          {tray.map((p) => (
            <Box
              key={p.id}
              draggable
              onDragStart={(e) => {
                if (e.dataTransfer) e.dataTransfer.effectAllowed = 'move';
                handlers.beginDrag(p.id, TRAY_ID);
              }}
              sx={{ cursor: 'grab' }}
            >
              <Chip label={PAGE_CATALOG[p.id]?.label ?? p.id} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
